var exports = {
  "root": "x24da60e8--fc52d2--root",
  "filters": "x24da60e8--fc52d2--filters",
  "main": "x24da60e8--fc52d2--main",
  "desktop": "x24da60e8--fc52d2--desktop",
  "container": "x24da60e8--fc52d2--container",
};

module.exports = exports;
